// Textos de disparo: biblioteca de textos prontos (do LucraLink) e salvos pelo
// usuario, inseridos no editor do Criar Post e do envio de ofertas. Usa as
// mesmas variaveis e o mesmo renderizador dos templates do encaminhamento
// (forwarding/template.ts): linha com variaveis todas ausentes some inteira.
import { buildTemplateVars, renderTemplate } from "../forwarding/template.js";
/** Teto de textos salvos por tenant. Espelhado na RPC upsert_broadcast_text. */
export const MAX_BROADCAST_TEXTS = 50;
export const MAX_BROADCAST_TEXT_NAME = 60;
export const MAX_BROADCAST_TEXT_BODY = 2000;
export const BROADCAST_TEXT_PRESETS = Object.freeze([
    {
        key: "achado-do-dia",
        name: "Achado do dia",
        body: "✨ Achado do dia\n\n{title}\n💰 {priceText}\n🎟️ Cupom: {coupon}\n\nVeja aqui 👉 {affiliateUrl}",
    },
    {
        key: "preco-baixou",
        name: "Preço baixou",
        body: "📉 O preço baixou!\n\n{title}\nDe {originalPrice} por {discountedPrice} ({discountPercent} off)\n\n🛒 {affiliateUrl}",
    },
    {
        key: "cupom-liberado",
        name: "Cupom liberado",
        body: "🎟️ Cupom liberado: {coupon}\n\n{title}\nSai {priceText} com o cupom aplicado no carrinho.\n\n👉 {affiliateUrl}",
    },
    {
        key: "ultimas-unidades",
        name: "Últimas unidades",
        body: "⚠️ Últimas unidades nesse preço\n\n{title}\n💸 {price}\n\nCorre antes que acabe: {affiliateUrl}",
    },
    {
        key: "economia",
        name: "Quanto você economiza",
        body: "💡 Economia de {savings}\n\n{title}\nAntes {originalPrice}, agora {discountedPrice}\n\n🔗 {affiliateUrl}",
    },
    {
        key: "recomendacao",
        name: "Recomendação pessoal",
        body: "Testei e recomendo 👇\n\n{title}\nEstá {priceText} na {provider}\n\n{affiliateUrl}",
    },
    {
        key: "bom-dia",
        name: "Bom dia com oferta",
        body: "☀️ Bom dia! Começando com oferta boa:\n\n{title}\n💰 {priceText}\n\n👉 {affiliateUrl}",
    },
    {
        key: "curto",
        name: "Curto e direto",
        body: "{title} - {price}\n{affiliateUrl}",
    },
]);
/** Variaveis do renderizador a partir do link. Desconto calculado quando ha preco original. */
export function broadcastVarsFromLink(link) {
    const original = link?.originalPriceCents ?? null;
    const price = link?.priceCents ?? null;
    const discountPercent = price !== null && original !== null && original > price ? Math.round(((original - price) / original) * 100) : null;
    return buildTemplateVars({
        title: link?.title ?? null,
        priceCents: price,
        originalPriceCents: original,
        discountPercent,
        coupon: link?.coupon ?? null,
    }, link?.url ?? null, link?.marketplaceCode ?? null);
}
/** Texto final para o editor (texto puro, sem marcacao). */
export function renderBroadcastText(body, link) {
    return renderTemplate(body, broadcastVarsFromLink(link), "plain");
}
//# sourceMappingURL=texts.js.map